import { EditOutlined, ShopOutlined, UserOutlined } from "@ant-design/icons";
import { Col, Row, Typography } from "antd";
import { compact, join } from "lodash";
import { useState } from "react";
import { useUpdateOrderPickup } from "hooks/pickup-receiver";
import { notify } from "utils/helperFuncs";
import PickupWarehouseSelect from "../PickupWarehouseSelect";

const PickupInfoSection = ({ order, canEdit, onRefetch }) => {
  const [visible, setVisible] = useState(false);

  const { handleUpdateOrderPickup } = useUpdateOrderPickup();

  const pickupInfo = order?.pickupInfo;
  const warehouse = pickupInfo?.warehouse;
  const receiver = pickupInfo?.receiver;
  const sellerID = order?.sellerID;

  const warehouseAddress = join(
    compact([warehouse?.address, warehouse?.ward?.name, warehouse?.district?.name, warehouse?.city?.name]),
    ", "
  );

  const handleConfirm = async ({ warehouseID, receiverID }) => {
    try {
      await handleUpdateOrderPickup({
        orderID: order?.id,
        warehouseID,
        pickupReceiverID: receiverID,
      });
      notify.success({ message: "Cập nhật thông tin nhận hàng tại kho thành công" });
      setVisible(false);
      onRefetch?.();
    } catch (err) {
      notify.error({ message: "Cập nhật thất bại", description: err?.message });
    }
  };

  return (
    <>
      <div
        onClick={canEdit ? () => setVisible(true) : undefined}
        style={{
          background: "#FFFFFF",
          border: "1px solid #E5E7EB",
          borderRadius: 12,
          overflow: "hidden",
          marginTop: 8,
          cursor: canEdit ? "pointer" : "default",
        }}
      >
        <Row align="middle" wrap={false} style={{ padding: "14px 20px" }}>
          <Col style={{ width: 140, flexShrink: 0 }}>
            <Row align="middle" gutter={6} wrap={false}>
              <Col>
                <ShopOutlined style={{ color: "#6B7280", fontSize: 14 }} />
              </Col>
              <Col>
                <Typography.Text style={{ fontWeight: 600, fontSize: 13, color: "#374151" }}>
                  Nhận tại kho
                </Typography.Text>
              </Col>
            </Row>
          </Col>
          <Col flex="auto">
            {warehouse?.name || receiver?.fullName ? (
              <div>
                {/* {warehouse?.name && (
                  <Typography.Text strong style={{ fontSize: 13, color: "#111827", display: "block" }}>
                    Kho {warehouse.name}
                  </Typography.Text>
                )} */}
                {receiver?.fullName && (
                  <Typography.Text strong style={{ fontSize: 13, color: "#374151" }}>
                    {join(compact([receiver.fullName, receiver.phone]), " | ")}
                  </Typography.Text>
                )}
              </div>
            ) : (
              <Typography.Text style={{ fontSize: 13, color: "#9CA3AF" }}>Chưa chọn</Typography.Text>
            )}
          </Col>
          {canEdit && (
            <Col>
              <EditOutlined style={{ color: "#2563EB", fontSize: 14 }} />
            </Col>
          )}
        </Row>
      </div>

      <PickupWarehouseSelect
        visible={visible}
        onClose={() => setVisible(false)}
        onConfirm={handleConfirm}
        sellerID={sellerID}
        initialWarehouseID={pickupInfo?.warehouseID}
        initialReceiverID={receiver?.id}
      />
    </>
  );
};

export default PickupInfoSection;
